const initialValues = {
  tempData: {
    title: '',
    description: '',
    competency_detail: [
      {
        competency_type: '',
        description_sub_skill: '',
        competency_group: '',
        detail: [
          {
            competency_level: '',
            value: '.',
            training: '',
            expected_output: '',
            performance_criteria: '',
            experience: '',
            learning_development: '',
            evidence: '',
            order: 1,
          },
        ],
      },
    ],
  },
  data: {
    title: '',
    description: '',
    competency_detail: [
      {
        competency_type: '',
        description_sub_skill: '',
        competency_group: '',
        detail: [
          {
            competency_level: '',
            value: '.',
            training: '',
            expected_output: '',
            performance_criteria: '',
            experience: '',
            learning_development: '',
            evidence: '',
            order: 1,
          },
        ],
      },
    ],
  },
};
export default initialValues;
